import { Pipe, PipeTransform } from '@angular/core';
import { RelationOperatorSearchText } from '@mtna/data-core-ts';

import { RdsChip } from '../chips/index';
import { RdsNumericFilter } from './numeric-filter.model';

/**
 * Turn `RdsNumericFilter` into RdsChips
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Pipe({
  name: 'rdsFiltersToChips',
})
export class RdsFiltersToChipsPipe implements PipeTransform {
  transform(value: Array<RdsNumericFilter> | null | undefined): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return (
      value
        .filter((f) => !!f.operation)
        // We can safely do a null assertion because of the filter
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        .map((f) => new RdsChip(RelationOperatorSearchText[f.operation!.type] + ' ' + f.value, f.operation!.type + f.value))
    );
  }
}
